import { Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useAssistantStore } from "./useAssistant";
import classes from "./AssistantWelcome.module.css";

const supportedEntityTypes = ["product", "schema", "import"];

export default function AssistantWelcome({ pageContext }) {
  const { t } = useTranslation();
  const sendMessage = useAssistantStore((s) => s.sendMessage);

  const entityType = supportedEntityTypes.includes(pageContext?.entityType)
    ? pageContext.entityType
    : "generic";

  const suggestions = t(`assistant.welcome.suggestions.${entityType}`, {
    returnObjects: true,
    defaultValue: [],
  });

  const header =
    entityType !== "generic" && pageContext?.entityName
      ? t("assistant.welcome.headerEntity", { name: pageContext.entityName })
      : t("assistant.welcome.headerGeneric");

  return (
    <Stack align="center" gap="md" mt="xl" px="sm">
      <ThemeIcon color="facetflux" radius="xl" size={48}>
        <Text fz={16} fw={700} c="white" lh={1}>
          AI
        </Text>
      </ThemeIcon>

      <Text size="sm" c="dimmed" ta="center">
        {header}
      </Text>

      <Stack gap="xs" w="100%">
        {suggestions.map((text) => (
          <Paper
            key={text}
            className={classes.suggestionCard}
            withBorder
            radius="md"
            p="sm"
            onClick={() => sendMessage(text, pageContext)}
          >
            <Text size="sm">{text}</Text>
          </Paper>
        ))}
      </Stack>
    </Stack>
  );
}
